module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<fieldset>\r\n  <div class="phx-formTable">\r\n    <div>\r\n      <span class="NDemandesText cw-texteAllege"></span> <span class="numDemandes cw-texteImportant"></span>\r\n      <br/><br/>\r\n\r\n      <span class="NDemandesAbandone cw-texteAllege"></span> <span class="numDemandesAbandone cw-texteImportant"></span>\r\n      <br/><br/>\r\n\r\n      <span class="NDemandesError cw-texteAllege"></span> <span class="numDemandesError cw-texteImportant"></span>\r\n      <br/>\r\n    </div>\r\n  </div>\r\n</fieldset>';
}
return __p;
};
